// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { PureComponent } from 'react';
import { COMMENT } from 'conversations-message-history/constants/tileMessageUses';
import TileMessage from '../tile-message/TileMessage';
// @ts-expect-error module not typed
import { getDeliveryStatus } from 'conversations-message-history/util/getDeliveryStatus';
// @ts-expect-error module not typed
import CommentMessageBody from './CommentMessageBody';
// @ts-expect-error module not typed
import { isMessageSoftDeleted } from 'conversations-message-history/common-message-format/operators/isMessageSoftDeleted';
import { jsx as _jsx } from "react/jsx-runtime";
class CommentMessage extends PureComponent {
  render() {
    const {
      message,
      onClickAvatar,
      handleClickToDelete,
      positionDescriptors,
      senderName,
      senders,
      visitorLastReadTimestamp,
      fileAttachments,
      onClickToDeleteComment,
      isHovered
    } = this.props;
    if (isMessageSoftDeleted(message)) {
      return null;
    }
    const timestamp = getTimestamp(message);
    const deliveryStatus = getDeliveryStatus(timestamp, visitorLastReadTimestamp);
    return /*#__PURE__*/_jsx(TileMessage, {
      use: COMMENT,
      positionDescriptors: positionDescriptors,
      children: /*#__PURE__*/_jsx(CommentMessageBody, {
        deliveryStatus: deliveryStatus,
        message: message,
        onClickAvatar: onClickAvatar,
        handleClickToDelete: handleClickToDelete,
        senderName: senderName,
        senders: senders,
        onClickToDeleteComment: onClickToDeleteComment,
        isHovered: isHovered,
        fileAttachments: fileAttachments
      })
    });
  }
}
CommentMessage.displayName = 'CommentMessage';
CommentMessage.defaultProps = {
  isHovered: false
};
export default CommentMessage;